<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="bg-white">
    <div class="">
      <div role="list" class="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div class="group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ voipProductAdded ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]">
          <div
            @click="handleClickAddVoipProduct"
            class="transition duration-250 relative flex-1 flex items-center justify-between "
            :class="[(voipProductAdded ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-2xl transition duration-250 text-black font-poppins-bold" :class="[voipProductAdded ? 'text-white' : 'text-black']">Yes</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
              <button v-if="!voipProductAdded" type="button" class="text-right mr-2 w-7 h-7 text-white rounded-full border border-solid"
                :class="[ voipProductAdded ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
              </button>
              <CheckCircleSolidIcon v-if="voipProductAdded" class="text-right pr-2 w-8 h-8 text-white" aria-hidden="true" />
            </div>
          </div>
        </div>
        <div class="group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ !voipProductAdded ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]">
          <div
            @click="handleClickRemoveVoipProduct"
            class="transition duration-250"
            :class="[(!voipProductAdded ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-2xl transition duration-250 text-black font-poppins-bold" :class="[ !voipProductAdded ? 'text-white' : 'text-black' ]">No</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
              <button v-if="voipProductAdded" type="button" class="text-right mr-2 w-7 h-7 text-white rounded-full border border-solid"
                :class="[ !voipProductAdded ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
              </button>
              <CheckCircleSolidIcon v-if="!voipProductAdded" class="text-right pr-2 w-8 h-8 text-white" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="voipProductAdded">
        <div class="mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4">
          <VoipSelectorProduct
            v-for="product in products"
            @handle-select-product="handleSelectProduct"
            :product="product"
            :key="product.name"
            :isSelectedProduct="isSelectedProduct(product)"
          />
        </div>
      </div>
      <div v-if="voipProductAdded" class="pt-8">
        <h2 class="text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0 font-normal">Voip Home Number Listed Or Listed?</h2>
        <div role="list" class="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div class="group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ voipListedNumber ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]">
            <div
              @click="handleClickListedVoipProduct"
              class="transition duration-250 relative flex-1 flex items-center justify-between"
              :class="[(voipListedNumber ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]"
              >
              <div class="flex-1 px-8 py-2 text-lg truncate">
                <p class="text-2xl transition duration-250 text-black font-poppins-bold" :class="[voipListedNumber ? 'text-white' : 'text-black']">Listed</p>
              </div>
              <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
                <button v-if="!voipListedNumber" type="button" class="text-right mr-2 w-7 h-7 text-white rounded-full border border-solid"
                  :class="[ voipListedNumber ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                  >
                </button>
                <CheckCircleSolidIcon v-if="voipListedNumber" class="text-right pr-2 w-8 h-8 text-white" aria-hidden="true" />
              </div>
            </div>
          </div>
          <div class="group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ !voipListedNumber ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark shadow-gray-400' : '' ]">
            <div
              @click="handleClickUnlistedVoipProduct"
              class="transition duration-250 relative flex-1 flex items-center justify-between"
              :class="[(!voipListedNumber ? 'border border-black' : 'border border-gray-200'), ('bg-transparent rounded-2xl truncate')]"
              >
              <div class="flex-1 px-8 py-2 text-lg truncate">
                <p class="text-2xl transition duration-250 text-black font-poppins-bold" :class="[!voipListedNumber ? 'text-white' : 'text-black']">Unlisted</p>
              </div>
              <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
                <button v-if="voipListedNumber" type="button" class="text-right mr-2 w-7 h-7 text-white rounded-full border border-solid"
                  :class="[ !voipListedNumber ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                  >
                </button>
                <CheckCircleSolidIcon v-if="!voipListedNumber" class="text-right pr-2 w-8 h-8 text-white" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
        <p class="text-base font-extralight mt-4 p-6 border border-solid rounded-xl border-black font-poppins">
          Your number will be set as unlisted by default but will be registered in the IPND database for emergency services.
          This can be changed at any time by contacting our friendly Australian-based support team on
          <a class="text-black font-bold hover:text-blue-800 hover:underline transition duration-250" target="_blank" :href="'mailto:' + voipInformation.email">{{ voipInformation.email }}</a>
          or <a  class="text-black font-bold hover:text-blue-800 hover:underline transition duration-250" target="_blank" :href="'tel:' + voipInformation.phone">{{ voipInformation.phone }}</a>. More information on IPND Policy can be found
          <a :href="voipInformation.csaAgreementUrl" target="_blank" class="text-black font-bold hover:text-blue-800 hover:underline transition duration-250">here.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>

import { defineProps, defineEmits, ref, watch } from 'vue';
import VoipSelectorProduct from './VoipSelectorProduct.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/vue/solid';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const voipInformation = brandService.getVoipInformation();

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}

const props = defineProps<{
  products: Array<Product>,
  isVoipAdded: boolean,
  isVoipListed: boolean,
  selected: string
}>();

const emit = defineEmits<{(e: 'onPlanSelected', id: string): void, (e: 'onVoipToggled', isVoipAdded: boolean): void, (e: 'onListingStatusToggled', isVoipListed: boolean): void}>();

// Start from the parent's state so a restored/loaded VoIP plan shows as "Yes".
const voipProductAdded = ref(props.isVoipAdded);
const voipListedNumber = ref(props.isVoipListed);
watch(() => props.isVoipAdded, (isVoipAdded) => {
  voipProductAdded.value = isVoipAdded;
});
watch(() => props.isVoipListed, (isVoipListed) => {
  voipListedNumber.value = isVoipListed;
});
const productSelected = ref<Product|null>();

const handleClickAddVoipProduct = () => {
  voipProductAdded.value = true;
  emit('onVoipToggled', true);
};

const handleClickRemoveVoipProduct = () => {
  voipProductAdded.value = false;
  emit('onVoipToggled', false);
};

const handleClickListedVoipProduct = () => {
  voipListedNumber.value = true;
  emit('onListingStatusToggled', true);
};

const handleClickUnlistedVoipProduct = () => {
  voipListedNumber.value = false;
  emit('onListingStatusToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onPlanSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};

</script>
